import {getAllBranchesOfRestaurant, getAllRestaurant} from "@/api/restaurants";

export default {
    methods: {
        formatDate(date) {
            return this.$moment.parseZone(date).local().format('DD/MM/YYYY hh:mm:ss A');
        },

        async fetchAllRestaurants() {
            let allRestaurants = await getAllRestaurant()
                .catch(ex => {
                    this.showErrorMessage(ex)
                });

            return allRestaurants.data;
        },

        async fetchBranchesOfRestaurant(restaurantId) {
            let params = new URLSearchParams();
            params.append("restaurant_id", restaurantId);
            let restaurantAllBranch = await getAllBranchesOfRestaurant(params);
            return restaurantAllBranch.data
        },

        async confirmFromUserBeforeDeleting (message) {
            return await Swal({
                title: 'Are you sure?',
                text: message,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1ab394',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            });
        },
    }
}